import api from "../../services/api";

const namespaced = true;

const state = {
  FDDList: [],
  selectedGroupNumber: null,
  freqClusterDateRange: [],
  FDDDateRange: []
};

const getters = {
  getFDD: state => state.FDDList,
  getSelectedGroupNumber: state => state.selectedGroupNumber,
  getFreqClusterDateRange: state => state.freqClusterDateRange,
  getFDDDateRange: state => state.FDDDateRange
};

const actions = {
  async fetchFDD({ commit, rootGetters }) {
    let selStructure = rootGetters["structure/getSelectedStructure"];
    if (selStructure) {
      let fromFDD = await api.getFDDList(selStructure._id, 2000, state.freqClusterDateRange[0], state.freqClusterDateRange[1]);
      commit("setFDD", fromFDD);
    }
  },
  async setSelectedGroupNumber({commit}, group){
    commit("selectGroupNumber", group);
  },
  async setFreqClusterDateRange({commit}, range){
    let firstDate = new Date(range[0]);
    let lastDate = new Date(range[1]);

    commit("setFreqClusterDateRange", [firstDate, lastDate]);
  },
  async setFreqFDDDateRange({commit}, range){
    let firstDate = new Date(range[0]);
    let lastDate = new Date(range[1]);

    commit("setDateRansetFreqFDDDateRangege", [firstDate, lastDate]);
  }
};

const mutations = {
  setFDD: (state, FDD) => (state.FDDList = FDD),
  selectGroupNumber: (state, group) => (state.selectedGroupNumber = group),
  setFreqClusterDateRange: (state, range) => (state.freqClusterDateRange = range),
  setFreqFDDDateRange: (state, range) => (state.FDDDateRange = range)
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
